/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Card from "../../components/card.component";
import licenciaFunction from "./licencia.functions";
import DataTable from "react-data-table-component";
import table from "./licencia.table";
import Modal from "../../components/modal/modal.component";
import { useForm } from "react-hook-form";
import utils from "../../utils/utils.functions";
import notification from "../../components/notification.component";
import pad from "pad";

const Licencia = () => {
  const [lista, setLista] = useState([]);
  const [company, setCompany] = useState({
    name: "",
    code: "",
    solvent: null,
  });
  const [selecteds, setSelectes] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [banco, setBanco] = useState(null);
  const [total, setTotal] = useState(0);
  const [clearTable, setClearTable] = useState(false);
  const [codigos, setCodigos] = useState({
    formato: "",
    limpio: [],
  });
  const { register, handleSubmit, reset, errors } = useForm();

  const onSubmit = (data) => {
    licenciaFunction.pago(data).then((response) => {
      if (response.payment_register) {
        notification.success();
        getLicencia();
        setSelectes([]);
        setTotal(0);
        modalActive();
        limpiarSelecciones();
      } else {
        notification.warning(
          "Ocurrio un error con el registro del pago intentelo nuevamente"
        );
      }
    });
  };

  const limpiarSelecciones = () => {
    setClearTable(!clearTable);
  };

  useEffect(() => {
    getLicencia();
  }, []);

  useEffect(() => {
    if (modalShow) {
      calculateMonto();
    }
  }, [modalShow]);

  const getLicencia = () => {
    licenciaFunction.data().then((response) => {
      let solvent = true;
      setLista(response.payments.invoices);
      response.payments.invoices.forEach((element) => {
        if (!element.status) {
          solvent = false;
        }
      });
      setCompany({
        name: response.payments.nombre_empresa,
        code: response.payments.codigo_plataforma,
        state: solvent,
      });
      setBanco(response.banco);
    });
  };

  const seleccion = (rows) => {
    setSelectes(rows.selectedRows);
  };

  const modalActive = () => {
    setModalShow(!modalShow);
  };

  const calculateMonto = () => {
    let total = 0;
    if (selecteds.length) {
      selecteds.forEach((e) => {
        total += e.total_amount;
      });

      const ids = selecteds.map((e) => pad(5, e.id, "0"));
      const idsClear = selecteds.map((e) => e.id);
      setCodigos({
        limpio: idsClear,
        formato: ids.join(),
      });
      reset({
        monto: utils.formatMoney(total),
        payment_ids: JSON.stringify(idsClear),
        licencia: company.code,
        reference_payment: "",
      });
      setTotal(total);
    }
  };

  const webpaypago = () => {
    const pagosSeleccionados = selecteds.map((e) => e.id);
    licenciaFunction.webpay({ pagos: pagosSeleccionados }).then((response) => {
      if (response.error) {
        if (!response.refrescar) {
          notification.warning("WebPay no responde intentelo mas tarde.");
        } else {
          notification.success("Actualización de pagos.");
          modalActive();
          limpiarSelecciones();
          getLicencia();
        }
      } else {
        modalActive();
        window.open(response.link_pago, "_blank");
      }
    });
  };

  return (
    <>
      <Row>
        <Col>
          <Card>
            <Row>
              <Col lg={4}>
                <div className="grupo-input">
                  <small>Empresa</small>
                  <div>{company.name}</div>
                </div>
              </Col>
              <Col lg={4}>
                <div className="grupo-input">
                  <small>Licencia</small>
                  <div>{company.code}</div>
                </div>
              </Col>
              <Col lg={4}>
                <div className="grupo-input">
                  <small>Estado</small>
                  <div style={{ color: company.state ? "black" : "red" }}>
                    {company.state ? "Solvente" : "Pagos pendientes"}
                  </div>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          <Card>
            <h4>¿Como pagar?</h4>
            <p>
              Seleccione solo los pagos que se encuentren en rojo con le estado
              "Pendiente", luego presione el boton pagar. Tiene 2 modalidades de
              pago:
              <ul>
                <li>
                  Por transferencia bancaria donde usted debe realizar la
                  transferencia y luego registrar el pago.
                </li>
                <li>
                  Puede ir directamente a la opción de pagar con <b>WebPay</b>{" "}
                  luego de hacer la selección y presionar el boton pagar.
                </li>
              </ul>
            </p>
          </Card>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          <Card>
            <DataTable
              title="Pagos"
              customStyles={table.customStyles}
              columns={table.colummnsPagos()}
              selectableRows={true}
              selectableRowsHighlight={true}
              clearSelectedRows={clearTable}
              onSelectedRowsChange={seleccion}
              selectableRowsNoSelectAll={true}
              data={lista}
              dense={true}
              pagination={true}
              noDataComponent={"No tiene pagos pendientes"}
              contextMessage={{
                singular: "Pago",
                plural: "Pagos",
                message: "seleccionados",
              }}
              subHeader={true}
              selectableRowDisabled={(row) => (row.status ? true : false)}
              subHeaderComponent={
                <>
                  <button
                    onClick={getLicencia}
                    className="btnx btnx-warn icon-table"
                  >
                    Actualizar pagos
                  </button>
                  <button
                    disabled={selecteds.length ? false : true}
                    onClick={modalActive}
                    className="btnx btnx-warn icon-table"
                  >
                    Pagar
                  </button>
                </>
              }
            />
          </Card>
        </Col>
      </Row>
      <Modal show={modalShow}>
        <Card>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              {banco !== null ? (
                <Row>
                  <Col lg={6}>
                    <div className="grupo-input">
                      <small>Banco</small>
                      <div>{banco.banco}</div>
                    </div>
                    <div className="grupo-input">
                      <small>Tipo cuenta</small>
                      <div>{banco.tipo_cuenta}</div>
                    </div>
                    <div className="grupo-input">
                      <small>Numero de cuenta</small>
                      <div>{banco.numero_cuenta}</div>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="grupo-input">
                      <small>Titular</small>
                      <div>{banco.nombre_cuenta}</div>
                    </div>
                    <div className="grupo-input">
                      <small>Rut</small>
                      <div>{banco.rut_cuenta}</div>
                    </div>
                  </Col>
                </Row>
              ) : null}

              <Row className="mb-3">
                <Col lg={6}>
                  <div className="grupo-input">
                    <small>Referencia del pago (Solo para transferencia)</small>
                    <input
                      type="text"
                      className={`form-control input-border ${
                        errors.reference_payment && "is-invalid"
                      }`}
                      name="reference_payment"
                      ref={register({ required: true })}
                    />
                  </div>
                  <div className="grupo-input">
                    <small>Monto total</small>
                    <input
                      type="text"
                      className={`form-control input-border`}
                      disabled
                      value={utils.formatMoney(total)}
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="grupo-input">
                    <small>Pagos seleccionados</small>
                    <div>{selecteds.length}</div>
                  </div>
                  <div className="grupo-input">
                    <small>Codigos de pagos</small>
                    <div>{codigos.formato}</div>
                  </div>
                </Col>
              </Row>
            </div>

            <div className="container-button-payment">
              <div>
                <input
                  type="hidden"
                  name="monto"
                  ref={register({ required: true })}
                />
                <input
                  type="hidden"
                  name="payment_ids"
                  ref={register({ required: true })}
                />
                <input
                  type="hidden"
                  name="licencia"
                  ref={register({ required: true })}
                />
                <button
                  onClick={modalActive}
                  type="button"
                  className="btnx btnx-warn icon-table"
                >
                  Cancelar
                </button>{" "}
                <button type="submit" className="btnx btnx-warn icon-table">
                  Registrar pago por transferencia
                </button>
              </div>
              <div className="button-webpay">
                <img
                  src="https://www.tiendawebchile.cl/wp-content/uploads/2017/09/logo-webpay-plus-3-copy.png"
                  style={{ width: 170 }}
                />
                <button
                  disabled
                  type="button"
                  onClick={webpaypago}
                  className="btnx btnx-warn icon-table"
                >
                  Pagar por webpay
                </button>
                <span>Temporalmente deshabilitado</span>
              </div>
            </div>
          </form>
        </Card>
      </Modal>
    </>
  );
};

export default Licencia;
